const isBrowser = typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export function readJsonStorage(key, fallback) {
  if (!isBrowser) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch (_) {
    return fallback;
  }
}

export function writeJsonStorage(key, value) {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_) {
    // Ignore quota/private-mode failures. In-memory Redux state remains usable.
  }
}

export function removeStorageItem(key) {
  if (!isBrowser) return;
  try {
    window.localStorage.removeItem(key);
  } catch (_) {
    // ignore
  }
}
